(function () {
    'use strict';

    function requestForProposalConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/requestForProposalConfiguration.html',
            link: function (scope) {

            }
        };
    }

    requestForProposalConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('requestForProposalConfiguration', requestForProposalConfiguration);
})();
